import { config } from '../config/index.js';
import * as OmValidationMessageHelper from '../helpers/validation-message-helper.js';

export function validateTime(value,{
    required = true,
    subject = 'Time',
    pronoun = config.PRONOUN.YOUR,
    date = null,
    retainSubjectCase
}={}) {
    const regEx = new RegExp(/^(?:[01]\d|2[0-3]):[0-5]\d$/);

    if (required && !value ) {
        return OmValidationMessageHelper.getRequiredMessage(subject, retainSubjectCase);
    }
    if (!value && !required) {
        return null;
    }
    const invalidMessage = OmValidationMessageHelper.getInvalidMessage(subject, retainSubjectCase);
    if (!regEx.test(value)) {
        return invalidMessage;
    }

    if (date) {
        const [day, month, year] = date.split("/").map(Number); // Extract day, month, year
        const selectedDate = new Date(year, month - 1, day); // Convert to Date object
        selectedDate.setHours(0, 0, 0, 0); // Reset time for accurate comparison

        const [hours, minutes] = value.split(":").map(Number);
        const inputTime = new Date();
        inputTime.setHours(hours, minutes, 0, 0); // Set user input time

        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time for comparison

        if (selectedDate.getTime() === today.getTime() && inputTime > new Date()) {
            return `${subject} cannot be in the future.`;
        }
    }
   
 return null
}